import React from 'react';
import { Link } from 'react-router-dom';
import './PartnerDemoPages.css';

const DEMO_REQUESTS = [
  { id: '1', from: 'Gulf Bank', framework: 'ISO 27001', requested: '2025-01-20', status: 'Pending response' },
  { id: '2', from: 'Qatar National Finance', framework: 'QCB', requested: '2025-01-18', status: 'In progress' },
  { id: '3', from: 'MENA Finance Co.', framework: 'GDPR', requested: '2025-01-10', status: 'Completed' },
];

function getBadgeClass(status: string) {
  if (status === 'Completed') return 'badge-success';
  if (status === 'In progress') return 'badge-warning';
  return 'badge-secondary';
}

export default function DemoPartnerAssessmentRequests() {
  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Assessment requests</span>
      </nav>
      <header className="page-header">
       
        <p className="page-subtitle mb-0">
          Requests from institutions to assess your compliance. Respond with questionnaires or evidence as required.
        </p>
      </header>

      <div className="card-partner">
        <div className="card-header-partner">Requests</div>
        <div className="card-body-partner p-0">
          <table className="table-partner">
            <thead>
              <tr>
                <th>Requesting institution</th>
                <th>Framework</th>
                <th>Requested</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {DEMO_REQUESTS.map((r) => (
                <tr key={r.id}>
                  <td>{r.from}</td>
                  <td>{r.framework}</td>
                  <td>{r.requested}</td>
                  <td><span className={`badge-partner ${getBadgeClass(r.status)}`}>{r.status}</span></td>
                  <td><button type="button" className="btn btn-partner-primary btn-sm">Respond</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-3">
        <Link to="/" className="btn btn-partner-outline">Back to dashboard</Link>
      </div>
    </div>
  );
}
